import { GatsbyBrowser } from 'gatsby'

declare global {
  interface Window {
    rudderanalytics: Record<string, any>
    rudderSnippetLoaded: boolean
    rudderSnippetLoading: boolean
    rudderSnippetLoadedCallback?: () => void
    rudderSnippetLoader: (callback: () => void) => void
  }
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = _ref => {
  const { prevLocation } = _ref

  function trackRudderStackPage() {
    const delay = 1000
    const urlString = window !== undefined ? window.location.href : ''
    const paramString = urlString.split('?')[1]
    const queryString = new URLSearchParams(paramString)
    const queryParams = {} as { gclid: string; utm_referrer: string }

    queryString.forEach((key, value) => {
      queryParams[key] = value
    })

    window.setTimeout(() => {
      if (window.rudderanalytics) {
        window.rudderanalytics.page('page_view', {
          branch: process.env.GATSBY_BRANCH,
          timezone: {
            name: Intl.DateTimeFormat().resolvedOptions().timeZone
          },
          gclid: queryParams.gclid ? queryParams.gclid : '',
          utm_referrer: queryParams.utm_referrer ? queryParams.utm_referrer : ''
        })

        if (qualified) {
          qualified('handleEvents', (name, data) => {
            window.rudderanalytics.track(name, data)
          })
          window.rudderanalytics.track('qualified_handle_event', {
            loaded: true
          })
        }
      }
    }, delay)
  }

  if (window.rudderSnippetLoaded === false) {
    if (window.rudderSnippetLoading === true) {
      // As the loading is in progress, set the alternate callback function
      // to track page
      window.rudderSnippetLoadedCallback = () => {
        trackRudderStackPage()
      }
    } else if (prevLocation) {
      // Trigger the script loader and set the callback function
      // to track page
      window.rudderSnippetLoadedCallback = undefined
      window.rudderSnippetLoader(() => {
        trackRudderStackPage()
      })
    } else {
      // As this is the first page, set the alternate callback function
      // to track page and wait for the scroll event to occur (for SDK to get loaded)
      window.rudderSnippetLoadedCallback = () => {
        trackRudderStackPage()
      }
    }
  } else {
    trackRudderStackPage()
  }
}

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = () => {
  window.scrollTo(0, 0)
  return false
}
